export const BLOCKED_PATIENTPATH_COUNTRIES = ["SG", "MY"];
